import axios from 'axios';
import { SECOND } from '@/shared/consts/time.const';

const instance = axios.create({
	baseURL: 'https://www.opinet.co.kr/api',
	headers: {
		'Content-Type': 'application/json',
	},
	params: {
		code: import.meta.env.VITE_OPINET_API_KEY,
		out: 'json',
	},

	timeout: SECOND,
});

export default instance;
